/**
 * @author Dmitry Mitsaliuk
 */
var MysaAttachmentController = (function () {
    function MysaAttachmentController($scope, socket, topic, env) {
        this.$scope = $scope;
        this.socket = socket;
        this.topic = topic;
        this.env = env;
        this.showAttachment = false;
        this.fetchMysaData = true;
        this.profileLoaded = false;
    }
    MysaAttachmentController.prototype.showHide = function () {
        var _this = this;
        this.showAttachment = this.showAttachment ? false : true;
        if (this.fetchMysaData) {
            this.socket.forward('getMysaAttachments', this.$scope);
            this.$scope.$on('socket:getMysaAttachments', function (event, data) {
                if (angular.isDefined(data.error)) {
                    _this.serverError = data.error;
                }
                else {
                    _this.data = data;
                    _this.profileLoaded = true;
                }
            });
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: {
                        id: this.topic.topic._id
                    },
                    function: 'getMysaAttachments',
                    script: 'config/config',
                    token: this.env.user.token
                }
            });
        }
        this.fetchMysaData = false;
    };
    MysaAttachmentController.$inject = ['$scope', 'socket', 'topic', 'env'];
    return MysaAttachmentController;
}());
var MysaAttachmentComponent = (function () {
    function MysaAttachmentComponent() {
        this.templateUrl = 'mysaattachment.html';
        this.controllerAs = 'vm';
        this.controller = MysaAttachmentController;
    }
    return MysaAttachmentComponent;
}());
angular
    .module('application')
    .component('attachmentMysaSection', new MysaAttachmentComponent());

//# sourceMappingURL=attachment.mysa.component.js.map
